
import { mapGetters, mapMutations } from 'vuex';
import { defineComponent } from 'vue';
import { authClient, userClient } from '@/apis';
import log from '@/utils/log';

export default defineComponent({
  data: () => ({
    nameOrMail: '',
    password: '',
  }),
  computed: {
    ...mapGetters(['userLoggedIn']),
  },
  mounted() {
    // 若用户已登录，跳转至个人首页
    if (this.userLoggedIn) {
      this.$router.push('/user');
    }
  },
  methods: {
    ...mapMutations(['setUserProfile']),
    getProfile() {
      userClient.getUserInfo({})
        .then((profile) => {
          this.setUserProfile(profile);
        })
        .catch((err) => {
          log.error(err);
        });
    },
    login() {
      if (!this.nameOrMail) {
        this.$message.warn('用户名或邮箱不能为空', 1.5);
        return;
      }
      if (!this.password) {
        this.$message.warn('密码不能为空', 1.5);
        return;
      }
      authClient.login({ nameOrMail: this.nameOrMail, password: this.password })
        .then(() => {
          this.$message.success('登录成功', 1);
          this.getProfile(); // 用户登录向后端请求profile的内容，并装入Vuex
          this.$router.push('/timetable');
        })
        .catch((e) => {
          log.error(e);
        });
    },
    handleKeyDown(e: KeyboardEvent) {
      // 监听回车键
      if (e.key === 'Enter') {
        this.login();
      }
    },
  },
});
